import {createContext, useContext, useEffect, useReducer} from "react";
import {useQueryContentList, useQueryContentListByUser} from "../../../api/cmsContent";
import {mediaMatch} from "../../../utils";
import {useNavigateTo} from "../../../hooks/useNavigateTo";
import {initialState, reducer, setBannerList, setBannerLoading, setMidBanner, setRecommendList, setRecommendLoading} from "./reducer";
import {useProduceCoupon} from "../../../api/couponReceive";
import useRequestTokenAuth from "../../../hooks/useRequestTokenAuth";
import useNotice from "../../../hooks/useNotice";
import {useTranslation} from "react-i18next";
import cookies from "../../../utils/cookies";

const Context = createContext(initialState);

function HomeController() {
  const { recevierCouponHandle } = useProduceCoupon();
  const navigateTo = useNavigateTo();
  const isMdmax = mediaMatch.isMdmax;
  const { dispatch } = useHomeContext();
  const [auth] = useRequestTokenAuth();
  const notice = useNotice();
  const { t } = useTranslation();
  const agentInfo = cookies.getAgentInfo()
  
  const {
    loading: bannerLoading, getBanner
  } = useQueryContentList();
  
  const {
    loading: recommendLoading, getRecommend,
  } = useQueryContentListByUser({ businessType: 1, placeCode: 72 });
  
  /**
   * 获取首页banner列表
   * @returns {Promise<void>}
   */
  const getBannerList = async () => {
    let { data, error } = await getBanner({ businessType: 3, placeCode: 1 });
    
    if (data) {
      // console.log(data,'@@@');
      let banner = data && data.length > 0 ? data[0].contentList : [];
      dispatch(setBannerList(banner));
    }
  };
  
  /**
   * 获取中间的banner
   * @returns {Promise<void>}
   */
  const getMidBanner = async () => {
    let { data } = await getBanner({
      businessType: 3,
      placeCode: 73
    });
    
    if (data) {
      dispatch(setMidBanner(data));
    }
  };
  
  /**
   * 获取推荐商品列表
   * @returns {Promise<void>}
   */
  const getRecommendList = async () => {
    let { data, error } = await getRecommend();
    if (data) {
      dispatch(setRecommendList(data));
    }
  };
  
  /**
   *  跳转到商品详情
   * @param id
   */
  const gotoProductDetail = (id) => {
    if (isMdmax) {
      navigateTo(`/goodsDetail?goodsId=${id}`);
    } else {
      let dir = window.location.pathname.endsWith('/') ? '' : '/';
      window.open(`${window.location.origin}${window.location.pathname}${dir}#/goodsDetail?goodsId=${id}`);
    }
  };
  
  /**
   * 领取优惠券
   * @param query
   * @returns {Promise<void>}
   */
  const recevierCoupon = async (query) => {
    await auth(null);
    
    let q = {
      couponId: query.id,
    };
    let { data } = await recevierCouponHandle(q);
    
    if (data) {
      notice.success(t('领取成功！'));
    }
  };
  
  useEffect(() => {
    dispatch(setBannerLoading(bannerLoading));
  }, [bannerLoading]);
  
  useEffect(() => {
    dispatch(setRecommendLoading(recommendLoading));
  }, [recommendLoading]);
  
  useEffect(()=>{
    if (agentInfo.isProduct === '0'){
     navigateTo('/bookingList')
    }
  },[])
  
  return {
    bannerLoading,
    getBannerList,
    getMidBanner,
    getRecommendList,
    gotoProductDetail,
    recevierCoupon
  };
  
}

function useHomeContext() {
  const { state, dispatch } = useContext(Context);
  
  return {
    state,
    dispatch,
  };
}

export {useHomeContext, HomeController};

export default function HomeContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  
  return (
    <Context.Provider
      value={{ state, dispatch }}
      reducer={reducer}>
      {children}
    </Context.Provider>
  );
}
